// extracted by mini-css-extract-plugin
module.exports = {"delimiter":"TransferTransactionDetails_delimiter_15pNf","footer":"TransferTransactionDetails_footer_3Gnqv","setup":"TransferTransactionDetails_setup_1VBq_"};